module.exports = __webpack_public_path__ + "static/media/sign_in.ee6330cb.svg";